"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RadioField;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Field = _interopRequireDefault(require("../Field"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function RadioField(props) {
  var value = props.value,
      options = props.options,
      className = props.className,
      onChange = props.onChange,
      disabled = props.disabled;
  return /*#__PURE__*/_react.default.createElement(_Field.default, _extends({}, props, {
    className: (0, _classnames.default)('frikin-radio-field', className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "control"
  }, Object.keys(options).map(function (o) {
    return /*#__PURE__*/_react.default.createElement("label", {
      className: (0, _classnames.default)('radio', {
        disabled: disabled
      }),
      key: o
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: "question",
      onChange: onChange,
      value: o,
      checked: value === o,
      disabled: disabled
    }), options[o].label);
  })));
}

RadioField.propTypes = {
  label: _propTypes.default.any,
  value: _propTypes.default.any,
  options: _propTypes.default.object,
  className: _propTypes.default.string,
  inline: _propTypes.default.bool,
  onChange: _propTypes.default.func
};